// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "LazyIdentificationForm" + "." + "d13ea4ede6866adcae5a" + ".css";
};